import type { FunctionComponent } from 'react';
import React from 'react';

/**
 * Plus icon.
 */
export const PlusIcon: FunctionComponent<unknown> = (props) => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.41449 4.14804V5.76315H4.24491V9.79071H5.92456V5.76315H9.77546V4.14804H5.92456V0.161377H4.24491V4.14804H0.41449Z"
        fill="#6B7A86"
      />
    </svg>
  );
};
